import classes from './PrivacyPolicy.module.scss';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { DownloadOutlined } from '@mui/icons-material';
import Navbar from 'components/navbar/Navbar';

const PrivacyPolicy = () => {
    return (
        <div className={classes.container}>
            <header className={classes.header}>
                <div className={classes.title}>
                    <img src="/assets/images/logo_sis_white.png" alt="logo sis" />
                    <Navbar />
                </div>
                <h1 className={classes.subtitle}>Privacy Policy</h1>
            </header>
            <main className={classes.main}>
                <div className={classes.content}>
                    <div className={classes.bodyHeader}>
                        <div className={classes.date}>
                            <CalendarMonthOutlinedIcon />
                            <span>
                                Ultimo aggiornamento:
                                <b> 20 Giugno 2025</b>
                            </span>
                        </div>
                        <a href="/assets/pdf/privacy_policy.pdf" download="Privacy Policy.pdf">
                            <DownloadOutlined />
                            Scarica versione .pdf
                        </a>
                    </div>
                    <div className={classes.body}>
                        <div>
                            <h1>INFORMATIVA PRIVACY APP MUVIN</h1>
                            <p>
                                Gentile Utente,
                                <br /> La informiamo che la presente informativa viene resa, ai sensi degli artt. 13 e 14 del
                                Regolamento (UE) 2016/679 (di seguito anche “<b>GDPR</b>”), in relazione al trattamento dei Suoi
                                dati personali svolto per mezzo dell’applicativo mobile denominato MUVIN (nel seguito, anche
                                l’“App”) che permette agli utenti dell’<b>App</b> (nel seguito, gli “<b>Utenti</b>”) di usufruire
                                dei servizi di parcheggio pubblico e di altri servizi accessori offerti da S.I.S. Segnaletica
                                Industriale S.r.l. (di seguito anche “<b>SIS</b>”).
                            </p>
                        </div>
                        <div>
                            <h1>CHI TRATTA I SUOI DATI?</h1>
                            <p>
                                Con riferimento ai suoi dati personali raccolti nell’ambito dei servizi di parcheggio pubblico e
                                della sosta tariffata su strada e parcheggi gestiti da SIS, La informiamo che:
                            </p>
                            <ul>
                                <li>
                                    <p>
                                        Il <b>Comune</b> di riferimento presso cui lei parcheggia ovvero effettua la sosta (di
                                        seguito anche il “<b>Comune</b>”) agisce in qualità di{' '}
                                        <b>autonomo titolare del trattamento</b> in relazione ai dati personali raccolti per, a
                                        titolo esemplificativo, le seguenti finalità:
                                    </p>
                                    <ol type="a">
                                        <li>
                                            <p>erogazione dei servizi di sosta a pagamento;</p>
                                        </li>
                                        <li>
                                            <p>
                                                gestione della vendita e conseguente emissione dei titoli di sosta e degli
                                                abbonamenti, nonché gestione dei pagamenti nell’ambito delle attività di rimozione
                                                dei mezzi in sosta vietata;
                                            </p>
                                        </li>
                                        <li>
                                            <p>regolamentazione delle soste e dei parcheggi a pagamento;</p>
                                        </li>
                                        <li>
                                            <p>
                                                verifica della regolarità dei titoli di pagamento della sosta e dei parcheggi a
                                                pagamento;
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                accertamento di eventuali violazioni alle norme del Codice della Strada in
                                                relazioni alla sosta a pagamento e gestione dei relativi procedimenti
                                                amministrativi;
                                            </p>
                                        </li>
                                        <li>
                                            <p>adempimento di obblighi amministrativi e/o fiscali.</p>
                                        </li>
                                    </ol>
                                    <p>
                                        Con riferimento alle suddette attività di trattamento SIS, in esecuzione del Contratto
                                        sottoscritto con il Comune a fronte della gestione dei servizi di sosta veicolare a
                                        pagamento nell’ambito del territorio comunale, agisce in qualità di responsabile del
                                        trattamento. <br />
                                        Per conoscere i dettagli relativi alle attività di trattamento svolte dal Comune di
                                        riferimento in qualità di autonomo titolare del trattamento, la invitiamo a prendere
                                        visione dell’informativa privacy resa disponibile dal Comune.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        la Società <b>S.I.S Segnaletica Industriale Stradale S.r.l.</b> opera in qualità di
                                        titolare del trattamento, con riferimento ai suoi dati personali raccolti per le seguenti
                                        finalità:
                                    </p>
                                    <ol type="a">
                                        <li>
                                            <p>Registrazione dell’Utente sull’App;</p>
                                        </li>
                                        <li>
                                            <p>Gestione dei servizi erogati tramite l’App, e gestione tecnica di quest’ultima;</p>
                                        </li>
                                        <li>
                                            <p>Adempiere agli obblighi di legge cui SIS è soggetta;</p>
                                        </li>
                                        <li>
                                            <p>
                                                Accertare, esercitare o difendere un diritto in sede giudiziaria o ogniqualvolta
                                                le autorità giurisdizionali esercitino le loro funzioni
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                Verificare il corretto utilizzo dell’App, individuare e prevenire frodi e
                                                applicare le procedure interne di compliance;
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                onsentire di portare a termine una potenziale fusione, cessione di beni, cessione
                                                d’azienda o di ramo d’azienda divulgando e trasferendo i suoi dati personali
                                                alla/e terza/e parte/i coinvolta/e.
                                            </p>
                                        </li>
                                    </ol>
                                    <p>
                                        Di seguito è riportata l’informativa resa da SIS in qualità di autonomo titolare del
                                        trattamento relativa ai trattamenti di dati personali effettuati in occasione
                                        dell’erogazione dei servizi di parcheggio pubblico tramite l’App (nel seguito, anche la “
                                        <b>Privacy Policy</b>
                                        ”).
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h1>PRIVACY POLICY RESA DA SIS IN QUALITA’ DI TITOLARE DEL TRATTAMENTO</h1>
                        </div>
                        <div>
                            <h1>1. TITOLARE DEL TRATTAMENTO, DPO E RELATIVI DATI DI CONTATTO</h1>
                            <p>
                                Il titolare del trattamento è <b>S.I.S Segnaletica Industriale Stradale S.r.l.</b> (di seguito “
                                <b>SIS</b>”), con sede legale in via Torquato Tasso,12 – CAP:06073 Frazione di Mantignana –
                                Corciano (PG), il quale può essere contattato al seguente indirizzo e-mail:{' '}
                                <a href="mailto:info@sis.city">info@sis.city</a>
                                <br />
                                SIS ha provveduto a nominare un Responsabile per la protezione dei dati personali (“<b>DPO</b>”),
                                il quale può essere contattato al seguente indirizzo e-mail:{' '}
                                <a href="mailto:privacy@sis.city">privacy@sis.city</a>
                            </p>
                        </div>
                        <div>
                            <h1>2. QUALI DATI TRATTIAMO? </h1>
                        </div>
                        <div>
                            <h1>2.1. Dati necessari per la registrazione</h1>
                        </div>
                        <div>
                            <h1 className={classes.underline}>
                                2.1.1. Informazioni conferite per la creazione del Profilo Utente;
                            </h1>
                            <p>
                                Per usufruire dei servizi offerti tramite l’App, l’Utente deve registrarsi creando un profilo
                                utente (anche “<b>Profilo Utente</b>”).
                            </p>
                            <p>
                                In sede di creazione del Profilo Utente, SIS raccoglie i seguenti dati personali: nome, cognome,
                                età, numero di telefono, nonché tipologia (automobile, motoveicolo ecc.) e targa del/dei veicolo/i
                                con il/i quale/i l’Utente intende usufruire del Servizio (richiesto a seguito della creazione
                                dell’account ma necessario al fine di poter usufruire dei servizi di sosta) e, facoltativamente,
                                un indirizzo e-mail.
                            </p>
                            <p>
                                Il conferimento di tali dati – ad esclusione dell’indirizzo e-mail – è necessario per registrarsi
                                all’App e/o per usufruire dei servizi erogati tramite la stessa.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>2.1.2. Dati di fatturazione</h1>
                            <p>
                                Tramite la sezione{' '}
                                <b>
                                    “Profilo” {'>'} “Account” {'>'} “Dati di fatturazione”
                                </b>
                                , l’utente può facoltativamente indicare i propri dati di fatturazione quali, la ragione sociale,
                                P.IVA, l’indirizzo di posta elettronica certificata, indirizzo.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>2.1.3. Single Sign-On:</h1>
                            <p>
                                Alternativamente alla creazione di un Profilo Utente come indicato al par. 2.1.1. che precede,
                                l’Utente può accedere all’App anche per mezzo dei propri profili Apple e Google. In tal caso, SIS
                                acquisirà i dati personali dell’Utente direttamente dai sopracitati soggetti terzi, senza
                                necessità di inserire ulteriori informazioni da parte dell’Utente. Per maggiori informazioni circa
                                i trattamenti di dati personali svolti nell’ambito della funzione Single Sign-on, la invitiamo a
                                leggere il par. 4.1.1 che segue
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>2.1.4. Dati di minori </h1>
                            <p>
                                La creazione del Profilo utente e l’utilizzo dell’App sono consentiti esclusivamente a coloro che
                                abbiano compiuto almeno 18 anni.
                            </p>
                            <p>
                                SIS la informa del fatto che questi ha previsto, sin dalla fase di progettazione, un meccanismo
                                che preclude l’accesso all’App da parte di Utenti di età inferiore ai 18 anni. A tale riguardo,
                                qualora SIS dovesse riscontrare, mediante la verifica dei dati inseriti in sede di registrazione,
                                che non ha compiuto 18 anni, le sarà impedito di registrarsi. Le ricordiamo, infatti, che, se ha
                                meno di 18 anni, non può registrarti né fornirci alcun dato personale, ed in ogni caso non ci
                                assumiamo alcuna responsabilità di eventuali dichiarazioni mendaci da lei fornite. Qualora ci
                                accorgessimo dell’esistenza di dichiarazioni non veritiere, procederemo immediatamente a
                                cancellare immediatamente il suo Profilo Utente e ogni ulteriore eventuale dato personale
                                acquisito.
                            </p>
                        </div>
                        <div>
                            <h1>2.2. Informazioni relative al Dispositivo utilizzato </h1>
                            <p>
                                Cliccando su “Installa” nello store (i.e. App Store, Play Store) sul dispositivo mobile utilizzato
                                dall’Utente (nel seguito, anche “<b>Dispositivo</b>”), quest’ultimo esprime un consenso esplicito.
                                Conferendo tale consenso, autorizza SIS a installare l’App, nonché a leggere alcuni dati –
                                personali e non – relativi al Dispositivo, il cui trattamento è necessario a consentire il buon
                                esito dell’installazione stessa (e.g. modello del Dispositivo, versione del sistema operativo,
                                risoluzione dello schermo, tipo di connessione, lingua ecc.). Trattandosi di informazioni il cui
                                trattamento è essenziale ai fini delle operazioni tecniche di installazione dell’App sul
                                Dispositivo, l’unico modo in cui l’Utente può opporsi a tale trattamento è disinstallare l’App.
                                Inoltre, il suo Profilo Utente è arricchito con il codice IMEI che consente l’identificazione
                                univoca del Dispositivo mobile utilizzato tutte le volte in cui lei effettua l’accesso al suo
                                Profilo Utente.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>
                                2.3. Informazioni derivanti dall’uso dei servizi erogati tramite l’App
                            </h1>
                            <p>
                                <b>
                                    <i>(i)</i> Informazioni relative alla/e sosta/e
                                </b>
                                : l’Utente, ogniqualvolta vorrà effettuare una sosta in una delle aree di parcheggio, strutture o
                                zone gestite da SIS, dovrà inserire la targa dello specifico veicolo in quel momento utilizzato
                                nell’apposita sezione dell’App, la quale effettuerà un controllo per verificare se il veicolo
                                benefici di condizioni tariffarie agevolate (e.g. tariffa standard, residenziale, etc.) in base
                                alla specifica area di sosta selezionata.
                            </p>
                            <p>
                                In tale ambito, in via incidentale, SIS potrebbe altresì trattare dati appartenenti a particolari
                                categorie di dati personali relativi, ad esempio, al suo stato di salute, per il riconoscimento di
                                tariffe agevolate e/o pass dedicati.
                            </p>
                            <p>
                                Inoltre, tramite l’App sarà possibile prendere visione dello storico delle soste, al fine di
                                consentire all’Utente di visionare le eventuali comunicazioni relative ai servizi acquistati e lo
                                storico dei servizi di cui ha usufruito.
                            </p>
                            <p>
                                <b>
                                    <i>(ii)</i> Informazioni relative ai pagamenti effettuati con la carta di credito/debito
                                </b>
                                : l’App consente agli Utenti di effettuare il pagamento delle soste nelle aree di parcheggio,
                                strutture e zone convenzionate con SIS. A tal fine, l’App è collegata alla piattaforma di
                                pagamento Nexi.
                            </p>
                            <p>In tale ambito, SIS tratta i seguenti dati:</p>
                            <ul>
                                <li>
                                    <p>identificativo univoco dell’Utente;</p>
                                </li>
                                <li>
                                    <p>
                                        dettaglio del servizio acquistato (tipologia e durata della sosta, data e ora
                                        dell’acquisto);
                                    </p>
                                </li>
                                <li>
                                    <p> numero della carta di credito/debito criptato secondo gli standard PCI-DSS;</p>
                                </li>
                                <li>
                                    <p> dati della transazione, limitatamente all’identificativo della transazione stessa. </p>
                                </li>
                            </ul>
                            <p>
                                SIS puntualizza sin da ora che, ad eccezione del numero di carta di credito, i dati relativi ai
                                pagamenti effettuati dall’Utente non sono in alcun modo trattati da SIS, ma esclusivamente e
                                direttamente dalla piattaforma di pagamento utilizzata, a cui l’App rimanda al momento del
                                pagamento. Per maggiori informazioni, si rimanda al par. 4.1.2 della presente Privacy Policy,
                                nonché alle Condizioni Generali dell’App.
                            </p>
                            <p>
                                <b>
                                    <i>(iii)</i> Informazioni relative ai pagamenti effettuati tramite Wallet
                                </b>
                                : in alternativa al pagamento effettuato direttamente tramite la carta di credito/debito per mezzo
                                della piattaforma di pagamento Nexi, il pagamento dei servizi da parte dell’Utente potrà avvenire
                                anche attraverso la costituzione di un conto (di seguito, il “<b>Wallet</b>”), nel quale l’Utente
                                può depositare un <i>plafond</i> di mezzi monetari che potranno essere utilizzati di volta in
                                volta per versare il corrispettivo dovuto per il servizio acquistato.
                            </p>
                            <p>
                                Il Wallet potrà essere alimentato dell’Utente attraverso un versamento a mezzo di carta di credito
                                sulla piattaforma di pagamento Nexi.
                            </p>
                            <p>In tale contesto, SIS tratta i seguenti dati:</p>
                            <ul>
                                <li>
                                    <p>identificativo univoco dell’Utente;</p>
                                </li>
                                <li>
                                    <p>
                                        dettaglio del servizio acquistato (tipologia e durata della sosta, data e ora
                                        dell’acquisto);
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        dati relativi al Wallet (quantitativo di mezzi monetari depositati come <i>plafond</i>);
                                    </p>
                                </li>
                                <li>
                                    <p> dati della transazione. </p>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h1 className={classes.underline}>2.4. Tecnologie traccianti</h1>
                            <p>
                                Tecnologie quali ad esempio SDK (Software Development Kit) e affini sono strumenti che permettono
                                di analizzare l’uso delle applicazioni in modo da evitare errori di sistema e migliorare la user
                                experience. Per tutte le informazioni in merito agli SDK e alle ulteriori tecnologie traccianti
                                impiegate da SIS nell’ambito dell’App, si rimanda alla Cookie Policy.
                            </p>
                        </div>
                        <div>
                            <h1>2.5. Informazioni relative alla geolocalizzazione</h1>
                            <p>
                                Qualora lei decida di attivare i servizi di geolocalizzazione sul suo Dispositivo, potremo
                                trattare i dati personali relativi alla sua posizione per consentirle di identificare le aree di
                                sosta, strutture o zone gestite da SIS a lei più prossime. Ricordiamo in ogni caso che il
                                conferimento del consenso al trattamento dei dati personali relativi alla geolocalizzazione è
                                assolutamente facoltativo e finalizzato esclusivamente a consentire all’Utente di individuare
                                attraverso la mappa le aree di sosta, strutture o zone gestite da SIS più vicine.
                            </p>
                        </div>
                        <div>
                            <h1>2.6. Informazioni relative alle sue ricerche</h1>
                            <p>
                                Tutte le volte che l’Utente effettua una ricerca relativa ad un indirizzo e/o area di sosta,
                                struttura o zona gestita da SIS dove intende effettuare una sosta, l’Utente stesso ha la
                                possibilità di salvare all’interno della sezione “<b>Preferiti</b>” le ricerche effettuate. In tal
                                caso SIS conserva le ricerche effettuate e inserite nell’apposita sezione “Preferiti”.
                            </p>
                        </div>
                        <div>
                            <h1>2.7. Informazioni sulle richieste inoltrate tramite la sezione “Segnala un problema”</h1>
                            <p>
                                Quando un Utente richiede informazioni al nostro Servizio Clienti tramite l’apposita sezione “
                                <b>Segnala un problema</b>”, lo stesso verrà identificato direttamente in base alle informazioni
                                legate al Profilo Utente. SIS tratterà inoltre ogni eventuale ulteriore informazione e dato
                                personale contenuto nella richiesta inviata con le modalità sopra descritte.
                            </p>
                        </div>
                        <div>
                            <h1>2.8. Dati di terzi</h1>
                            <p>
                                Qualora lei decida di fornirci dati personali di terzi, la preghiamo di assicurarsi che questi
                                soggetti siano stati preventivamente e adeguatamente informati sulle modalità e le finalità di
                                trattamento qui indicate, accertandosi altresì del fatto che il trattamento di tali dati trovi
                                fondamento in una delle basi giuridiche di cui all’art. 6 del GDPR. In relazione a tale ipotesi,
                                lei si pone come autonomo titolare del trattamento, assumendosi tutti gli obblighi e le
                                responsabilità di legge e manlevando espressamente SIS verso ogni richiesta di risarcimento,
                                contestazione o pretesa che dovesse essere avanzata nei confronti di SIS stessa da parte dei terzi
                                i cui dati personali siano stati trattati tramite l’App sotto la sua responsabilità.
                            </p>
                        </div>
                        <div>
                            <h1>3. FINALITA’, BASE GIURIDICA E DATI PERSONALI OGGETTO DI TRATTAMENTO </h1>
                            <p>SIS tratterà i suoi dati personali per le seguenti finalità:</p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>3.A. Registrazione del Profilo Utente</h1>
                            <p>
                                I dati raccolti in sede di registrazione del Profilo Utente sono trattati esclusivamente al fine
                                di consentire all’Utente di usufruire appieno dei servizi e delle funzionalità offerti da SIS per
                                mezzo dell’App e, in particolare:
                            </p>
                            <ol type="I">
                                <li>
                                    <p>per finalità legate alla gestione del Profilo Utente;</p>
                                </li>
                                <li>
                                    <p>per finalità di assistenza clienti e di gestione e prevenzione delle frodi;</p>
                                </li>
                                <li>
                                    <p>
                                        per finalità di invio di comunicazione e aggiornamenti strettamente legati al
                                        funzionamento dell’App.
                                    </p>
                                </li>
                            </ol>
                            <p>
                                Ne consegue che il suddetto trattamento è necessario a tal fine e che, in caso di mancato
                                conferimento dei dati necessari per le finalità sopra indicate, le sarà preclusa la possibilità di
                                creare il proprio Profilo Utente e conseguentemente usufruire dell’App.
                            </p>
                            <p>
                                Teniamo a precisare, in ogni caso, che gli unici dati il cui conferimento è necessario in tal
                                senso sono quelli previsti come obbligatori nel form di registrazione del Profilo Utente. Il
                                mancato conferimento di eventuali ulteriori dati facoltativi (e.g. indirizzo e-mail), invece, non
                                comporterà alcun pregiudizio.
                            </p>
                            <p>
                                <b>Base giuridica</b>: esecuzione di contratti o di misure precontrattuali di cui l’interessato è
                                parte (art. 6, par. 1, lett. b del GDPR).
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati saranno conservati sino a quando il Profilo
                                Utente non verrà cancellato e, successivamente, ove strettamente necessario, per il periodo di
                                prescrizione applicabile ai sensi dell’art. 2947 commi 1 e 3 c.c..
                            </p>
                            <p>
                                Fermo quanto sottoindicato relativamente alla conservazione dei dati a seguito della cancellazione
                                del Profilo Utente, se decide di cancellare il suo Profilo Utente, i suoi dati verranno conservati
                                per un periodo non superiore a 3 mesi per finalità esclusivamente amministrative, fatti salvi
                                ulteriori periodi di conservazione determinati in base alla necessità di tutela dei nostri
                                legittimi interessi (e.g. in caso di gestione di reclami e/o contestazioni in via giudiziale e/o
                                stragiudiziale) e/o previsti da specifiche norme di legge.
                            </p>
                            <p>
                                <span className={classes.underline}>
                                    La informiamo sin da ora che, a seguito del mancato accesso al Profilo Utente per un periodo
                                    superiore a 24 mesi, provvederemo a cancellare il suo Profilo Utente e tutti i suoi dati
                                    personali
                                </span>
                                , fatta salva l’eventuale ulteriore conservazione di tali dati ove necessaria al fine di adempiere
                                ad obblighi di legge e/o di tutelare i nostri legittimi interessi.{' '}
                                <span className={classes.underline}>
                                    Prima di procedere alla cancellazione del suo Profilo Utente, tuttavia, la contatteremo
                                    affinché ci possa comunicare se desidera mantenerlo attivo.
                                </span>{' '}
                                In caso di suo riscontro negativo o in assenza di riscontro, provvederemo a cancellare il Profilo
                                Utente, sicché non sarà più in grado di accedervi con le vecchie credenziali e, ove fosse
                                interessato a continuare ad usufruire dei servizi messi a disposizione da SIS tramite l’App, sarà
                                necessario crearne uno nuovo.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>3.B. Servizi di sosta e relativi pagamenti</h1>
                            <p>In tale ambito, trattiamo i suoi dati personali: </p>
                            <ol type="i">
                                <li>
                                    <p>
                                        per finalità legate alla gestione degli ordini e ai pagamenti effettuati mediante l’App
                                        con le due modalità sopra descritte ai par. 2.3(ii) e 2.3(iii);
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        per finalità di gestione contabile e adempimento di obblighi amministrativi e/o fiscali
                                        e/o legali relativi ai servizi resi di gestione delle aree di sosta, infrastrutture e zone
                                        gestite da SIS;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        per finalità di assistenza clienti, anche in relazione ad eventuali suoi reclami e
                                        segnalazioni.
                                    </p>
                                </li>
                            </ol>
                            <p>
                                La informiamo che il trattamento dei suoi dati nell’ambito delle attività e per le finalità
                                sopraindicate è indispensabile, e che il loro mancato conferimento precluderà la possibilità di
                                fruire dei servizi di sosta.
                            </p>
                            <p>
                                <b>Base giuridica</b>: esecuzione di contratti o di misure precontrattuali di cui l’interessato è
                                parte (art. 6, par. 1, lett. b del GDPR). Con specifico riferimento ai dati personali appartenenti
                                a categorie particolari di dati che SIS potrebbe in via incidentale trattare, la base giuridica
                                del trattamento è il trattamento di dati personali resi manifestamente pubblici dall'interessato
                                (art. 9 par 2, lett. e del GDPR).
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: termine di prescrizione previsto dalla legge (dieci anni dal
                                conferimento dei dati), salvi ulteriori periodi di conservazione determinati in base alla
                                necessità di tutela dei nostri legittimi interessi (ad esempio, gestione di reclami, segnalazioni,
                                procedimenti legali, richieste degli interessati ecc.).
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>3.C. Marketing diretto </h1>
                            <p>
                                Trattiamo i suoi dati personali, previo suo consenso libero, specifico e informato, per
                                aggiornarla sulle nostre iniziative promozionali, commerciali e pubblicitarie, su eventi o
                                iniziative nonché per condurre indagini di mercato e di soddisfazione degli utenti, in conformità
                                a quanto previsto dal provvedimento dell’Autorità Garante per la protezione dei dati personali{' '}
                                <i>
                                    “Linee guida in materia di attività promozionale e contrasto allo spam – 4 luglio 2013
                                    [2542348]”
                                </i>
                                .
                            </p>
                            <p>
                                Nel caso lei decida di prestare il suo consenso, la informiamo che tali attività potranno essere
                                esercitate, come previsto dalla vigente disciplina, per mezzo di posta cartacea, contatti
                                telefonici tramite operatore (“<b>modalità tradizionali</b>”), e-mail, invio di SMS e notifiche
                                push (“<b>modalità automatizzate</b>”). A tal riguardo, precisiamo che, fatto salvo il caso delle
                                notifiche push, raccoglieremo un unico consenso per le finalità di marketing sopra indicate, in
                                conformità alle sopracitate Linee Guida. Inoltre, tratteremo i suoi dati per svolgere attività di
                                analisi e di reportistica connesse ai sistemi di comunicazione promozionale, come ad esempio il
                                rilevamento del numero delle e-mail aperte, dei click effettuati sui link presenti all’interno
                                della comunicazione, la tipologia del Dispositivo utilizzato per leggere la comunicazione, il
                                relativo sistema operativo o l’elenco dei disiscritti alla <i>newsletter</i>.
                            </p>
                            <p>
                                In mancanza di un suo specifico consenso, non potremo trattare i suoi dati personali per finalità
                                di marketing diretto e non potremo quindi informarla sulle nuove promozioni in corso. In ogni
                                caso, il consenso è libero e assolutamente facoltativo. Pertanto, anche se non ci conferirà il suo
                                consenso per le finalità di marketing, potrà comunque usufruire di tutte le funzionalità dell’App.
                            </p>
                            <p>
                                Con riferimento alle notifiche push dell’App, puntualizziamo che queste potranno essere attivate
                                tramite i banner pop-up che compariranno una volta installata l’App e che le potrà disattivare
                                direttamente dalle impostazioni del suo Dispositivo o dalla sottoindicata sezione dell’App.
                            </p>
                            <p>
                                Resta inteso che potrà revocare in ogni momento il consenso precedentemente prestato al
                                trattamento dei suoi dati personali per finalità di marketing (incluse le eventuali attività
                                promozionali svolte tramite notifiche push) modificando le sue preferenze nell’apposta sezione:
                                <b> “Profilo” {'>'} “Informazioni legali”</b>
                            </p>
                            <p>
                                La revoca del suo consenso non pregiudicherà, in ogni caso, la liceità dei trattamenti effettuati
                                per finalità di marketing in base al suo consenso prima della revoca stessa.
                            </p>
                            <p>
                                <b>Base giuridica</b>: consenso facoltativo (art. 6, par. 1, lett. a del GDPR)
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: I suoi dati personali trattati per finalità di marketing
                                diretto saranno conservati sino alla data di revoca del consenso e, successivamente, per il tempo
                                e nella misura in cui ciò sia necessario a consentirci di adempiere ad obblighi di legge e/o
                                tutelare i nostri diritti e interessi legittimi (ad esempio, gestione di reclami, segnalazioni,
                                procedimenti legali, richieste degli interessati ecc.), entro i termini prescrizionali
                                applicabili. Resta in ogni caso ferma la liceità dei trattamenti effettuati in base al consenso
                                prima della revoca.
                            </p>
                            <p>
                                Il dettaglio dei suoi acquisti trattato per finalità di marketing, invece, potrà essere conservato
                                per un periodo non superiore a 24 mesi dalla raccolta, fatta salva la facoltà del Titolare di
                                conservare tali dati per tempistiche ulteriori in forma esclusivamente anonima.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>3.F. Funzione di geolocalizzazione</h1>
                            <p>
                                Al fine di consentire all’Utente di individuare attraverso una mappa le aree di sosta, strutture o
                                zone gestite da SIS più vicine, trattiamo i dati personali relativi alla ubicazione del
                                Dispositivo dell’Utente solo nel caso in cui lo stesso abbia acconsentito alla geolocalizzazione
                                del Dispositivo ed attivato l’utilizzo dei servizi di geolocalizzazione dal suo Dispositivo.
                            </p>
                            <p>
                                Il consenso per il trattamento dei dati personali relativi alla posizione dell’Utente per questa
                                finalità è del tutto facoltativo e non pregiudica la fruizione dei servizi di sosta erogati da SIS
                                tramite l’App, ma solo la possibilità di individuare attraverso una mappa le aree di sosta,
                                strutture o zone gestite da SIS più vicine.
                            </p>
                            <p>
                                <b>Base giuridica</b>: consenso facoltativo (art. 6, par. 1, lett. a del GDPR).
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i dati personali relativi alla posizione geografica del
                                Dispositivo saranno trattati per il tempo strettamente necessario all’utilizzo dei servizi
                                richiesti e non saranno memorizzati o utilizzati per altre finalità, fatti comunque salvi i
                                periodi di conservazione determinati in base alla legge o a motivi legittimi.
                            </p>
                            <p>
                                Le ricordiamo che, in ogni caso, ha la possibilità di disattivare la geolocalizzazione del suo
                                Dispositivo in qualunque momento, anche temporaneamente, mediante le impostazioni del Dispositivo,
                                secondo le seguenti modalità:
                            </p>
                            <ul>
                                <li>
                                    <p>
                                        <b>iOS</b>: è necessario andare su “Impostazioni” {'>'}
                                        “Privacy” {'>'} “Servizi di Localizzazione” e selezionare “Mai” in corrispondenza
                                        dell’App.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <b>Android</b>: è necessario andare su “Impostazioni” {'>'}
                                        “Impostazioni avanzate” {'>'} “Servizi di localizzazione” e disattivare l’App dall’elenco.
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h1 className={classes.underline}>
                                3.G. Dare riscontro alle richieste inoltrate tramite la sezione “Segnala un problema”
                            </h1>
                            <p>
                                Mediante l’accesso alla sezione <b className={classes.underline}>“Segnala un problema”</b>,
                                l’Utente ha la possibilità di inoltrare una richiesta di informazioni e/o di effettuare una
                                segnalazione.
                            </p>
                            <p>
                                <b>Base giuridica</b>: esecuzione di contratti o di misure precontrattuali di cui l’interessato è
                                parte (art. 6, par. 1, lett. b del GDPR).
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati personali saranno trattati per il tempo
                                strettamente necessario per evadere la sua richiesta di informazioni e/o verificare quanto
                                segnalato, e comunque per un periodo non superiore a 24 mesi.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>3.H. Adempiere agli obblighi di legge cui siamo soggetti</h1>
                            <p>
                                SIS potrebbe avere la necessità di trattare i suoi dati personali al fine di adempiere ad obblighi
                                di legge a cui la stessa è soggetta.
                            </p>
                            <p>
                                <b>Base giuridica</b>: adempimento di obblighi legali a cui il Titolare è soggetto (art. 6, par.
                                1, lett. c del GDPR).
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati personali verranno trattati per il periodo
                                strettamente necessario a consentirci di adempiere agli obblighi di legge a cui siamo soggetti e,
                                in ogni caso, saranno conservati per un periodo di tempo massimo di 10 anni.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>3.I. Gestione tecnica dell’App</h1>
                            <p>
                                SIS potrebbe avere la necessità di trattare i suoi dati personali al fine di garantire la corretta
                                gestione tecnica dell’App.
                            </p>
                            <p>
                                <b>Base giuridica</b>: legittimo interesse del Titolare (art. 6, par. 1, lett. f del GDPR)
                            </p>
                            <p>
                                Con particolare riferimento a tale finalità, si specifica che il legittimo interesse di SIS a
                                trattare i dati è equamente bilanciato con i suoi interessi, diritti e libertà fondamentali. Il
                                trattamento basato sull’interesse legittimo non è obbligatorio e potrà opporsi a detto trattamento
                                con le modalità di cui alla presente Privacy Policy e, in tale caso, SIS non potrà trattare i dati
                                personali per tale finalità, a meno che lo stesso dimostri la presenza di motivi legittimi
                                prevalenti.
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati personali verranno trattati per finalità legate
                                alla gestione tecnica dell’App per il periodo strettamente necessario a perseguire tale finalità
                                e, in ogni caso, per un periodo non superiore 12 mesi.
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>
                                3.J. Accertare, esercitare o difendere un diritto in sede giudiziaria o ogniqualvolta le autorità
                                giurisdizionali esercitino le loro funzioni
                            </h1>
                            <p>
                                Potremmo avere la necessità di trattare i suoi dati personali anche al fine di consentirci di
                                accertare, esercitare o difendere un diritto in sede giudiziaria o ogniqualvolta le autorità
                                giurisdizionali esercitino le loro funzioni.
                            </p>
                            <p>
                                <b>Base giuridica</b>: legittimo interesse del Titolare (art. 6, par. 1, lett. f del GDPR).
                            </p>
                            <p>
                                Con particolare riferimento a tale finalità, si specifica che il legittimo interesse di SIS a
                                trattare i dati è equamente bilanciato con i suoi interessi, diritti e libertà fondamentali. Il
                                trattamento basato sull’interesse legittimo non è obbligatorio e potrà opporsi a detto trattamento
                                con le modalità di cui alla presente Privacy Policy e, in tale caso, SIS non potrà trattare i dati
                                personali per tale finalità, a meno che lo stesso dimostri la presenza di motivi legittimi
                                prevalenti.
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati personali verranno trattati per il periodo di
                                tempo strettamente necessario per consentirci di difendere i nostri diritti e legittimi interessi
                                in ambito giudiziale e stragiudiziale e, in ogni caso, per il tempo massimo di prescrizione
                                applicabile ai sensi dell’art. 2947 commi 1 e 3 c.c..
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>
                                3.K. Verificare il corretto utilizzo dell’App, individuare e prevenire frodi e applicare le
                                procedure interne di compliance
                            </h1>
                            <p>
                                SIS potrebbe trattare i suoi dati personali al fine di individuare e prevenire frodi e per
                                garantire il rispetto delle condizioni generali dell’App e delle leggi applicabili. Inoltre,
                                potremmo trattare i suoi dati personali al fine di applicare e far rispettare le nostre procedure
                                interne di compliance.
                            </p>
                            <p>
                                <b>Base giuridica</b>: legittimo interesse del Titolare (art. 6, par. 1, lett. f del GDPR).
                            </p>
                            <p>
                                Con particolare riferimento a tale finalità, si specifica che il nostro legittimo interesse a
                                trattare i dati è equamente bilanciato con i suoi interessi, diritti e libertà fondamentali. Il
                                trattamento basato sull’interesse legittimo non è obbligatorio e potrà opporsi a detto trattamento
                                con le modalità di cui alla presente Privacy Policy e, in tale caso, SIS non potrà trattare i dati
                                personali per tale finalità, a meno che la stessa dimostri la presenza di motivi legittimi
                                prevalenti.
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati personali saranno trattati per il periodo di
                                tempo strettamente necessario a consentirci di soddisfare il nostro legittimo interesse. In ogni
                                caso, conserveremo tali dati personali per un massimo di 12 mesi e, successivamente, per il tempo
                                e nella misura in cui ciò sia necessario a consentirci di adempiere ad obblighi di legge e/o
                                tutelare i nostri diritti e interessi legittimi (ad esempio, gestione di reclami, segnalazioni,
                                procedimenti legali, richieste degli interessati ecc.), entro i termini prescrizionali applicabili
                                (10 anni).
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>
                                3.L. Consentire a SIS di portare a termine una potenziale fusione, cessione di beni, cessione
                                d’azienda o di ramo d’azienda divulgando e trasferendo i suoi dati personali alla/e terza/e
                                parte/i coinvolta/e
                            </h1>
                            <p>
                                Potremmo avere la necessità di trattare i suoi dati personali per effettuare operazioni
                                straordinarie quali fusioni, acquisizioni, scissioni, cessioni di rami d’azienda ecc..
                            </p>
                            <p>
                                <b>Base giuridica</b>: legittimo interesse del Titolare (art. 6, par. 1, lett. f del GDPR).
                            </p>
                            <p>
                                Con particolare riferimento a tale finalità, si specifica che il nostro legittimo interesse a
                                trattare i dati è equamente bilanciato con i suoi interessi, diritti e libertà fondamentali. Il
                                trattamento basato sull’interesse legittimo non è obbligatorio e potrà opporsi a detto trattamento
                                con le modalità di cui alla presente Privacy Policy e, in tale caso, SIS non potrà trattare i dati
                                personali per tale finalità, a meno che la stessa dimostri la presenza di motivi legittimi
                                prevalenti.
                            </p>
                            <p>
                                <b>Tempistiche di conservazione</b>: i suoi dati personali verranno trattati per il periodo
                                strettamente necessario a portare a termine la/e operazione/i e, successivamente, per il tempo e
                                nella misura in cui ciò sia necessario a consentirci di adempiere ad obblighi di legge e/o
                                tutelare i nostri diritti e interessi legittimi (ad esempio, gestione di reclami, segnalazioni,
                                procedimenti legali, richieste degli interessati ecc.), entro i termini prescrizionali applicabili
                                (10 anni).
                            </p>
                        </div>
                        <div>
                            <h1>4. DESTINATARI DEL TRATTAMENTO E TRASFERIMENTO DEI DATI</h1>
                            <p>I dati personali degli Utenti potranno essere trattati da e condivisi con:</p>
                            <ol type="a">
                                <li>
                                    <p>il Comune presso cui Lei parcheggia ovvero effettua la sosta;</p>
                                </li>
                                <li>
                                    <p>
                                        soggetti autorizzati dal Titolare, che siano impegnati alla riservatezza o, in ogni caso,
                                        soggetti ad adeguato obbligo legale di riservatezza;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        soggetti delegati e/o incaricati da SIS di svolgere attività strettamente correlate al
                                        perseguimento delle finalità sopra indicate (inclusi interventi di gestione e manutenzione
                                        tecnica dei sistemi informativi), giustamente nominati responsabili del trattamento;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        il fornitore della piattaforma di pagamento collegata all’App (i.e. Nexi) con il quale SIS
                                        ha sottoscritto un apposito accordo al fine di disciplinare le questioni attinenti alla
                                        protezione dei dati personali;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        persone, società o studi professionali che prestano attività di assistenza e consulenza al
                                        Titolare, giustamente nominati responsabili del trattamento;
                                    </p>
                                </li>
                                <li>
                                    <p>banche e istituti di credito e/o istituti assicurativi;</p>
                                </li>
                                <li>
                                    <p>
                                        soggetti, enti od autorità a cui la comunicazione dei suoi dati personali sia obbligatoria
                                        in forza di disposizioni di legge o di ordini delle autorità competenti;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        soggetti terzi nell’ambito di eventuali operazioni straordinarie che dovessero coinvolgere
                                        SIS;
                                    </p>
                                </li>
                                <li>
                                    <p>altre società del gruppo di appartenenza di SIS.</p>
                                </li>
                            </ol>
                            <p>
                                In ogni caso, ai soggetti citati saranno comunicati solo i dati necessari e pertinenti rispetto
                                alle finalità del trattamento cui sono preposti.
                            </p>
                            <p>
                                I suoi dati personali potranno essere trasferiti al di fuori dello Spazio Economico Europeo (nel
                                seguito, anche “<b>SEE</b>”). Il trasferimento dei suoi dati personali fuori dallo SEE avverrà nel
                                pieno rispetto della normativa applicabile in materia di protezione dei dati personali e delle
                                linee guida e raccomandazioni emanate dalle competenti Autorità di Controllo.
                            </p>
                        </div>
                        <div>
                            <h1>4.1. Altri destinatari</h1>
                        </div>
                        <div>
                            <h1 className={classes.underline}>4.1.1. Single sign-on</h1>
                            <p>
                                Come precisato al par. 2.1.2. che precede, SIS offre la possibilità di accedere all’App tramite
                                gli account che l’Utente già possiede con i provider indicati nei successivi paragrafi.
                            </p>
                        </div>
                        <div>
                            <h1>
                                <i>4.1.1.1. Apple</i>
                            </h1>
                            <p>
                                Se lei utilizza dispositivi iOS, le offriamo la possibilità di registrarsi e accedere all’App con
                                il suo ID Apple.
                            </p>
                            <p>
                                Se sceglie di avvalersi di questa funzionalità, Apple Distribution International Limited, con sede
                                a Hollyhill Industrial Estate, Hollyhill, Cork, Irlanda o l'altra entità del Gruppo Apple che
                                fornisce il servizio (di seguito “<b>Apple</b>”) ci fornirà alcune informazioni su di lei – come
                                il suo indirizzo e-mail e il suo nome – necessarie per permetterle di accedere all’App. A questo
                                proposito, sottolineiamo che Apple le permette di scegliere le informazioni che condivide con SIS,
                                nonché di utilizzare pseudonimi e/o di nascondere il suo indirizzo e-mail.
                            </p>
                            <p>
                                la preghiamo di notare che, nel contesto del meccanismo di single sign-on, Apple tratterà i suoi
                                dati personali in qualità di autonomo titolare del trattamento per le proprie finalità (ad
                                esempio, per prevenire frodi). Per ottenere maggiori informazioni sul trattamento dei dati
                                personali effettuato da Apple attraverso il meccanismo del single sign-on, può consultare le
                                informative sulla privacy di Apple, disponibili agli indirizzi{' '}
                                <a href="https://www.apple.com/legal/privacy/data/it/sign-in-with-apple/">
                                    https://www.apple.com/legal/privacy/data/it/sign-in-with-apple/
                                </a>{' '}
                                e <a href="https://www.apple.com/it/legal/privacy/">https://www.apple.com/it/legal/privacy/</a>.
                            </p>
                            <p>
                                La informiamo che Apple potrebbe trasferire i suoi dati personali al di fuori del SEE, anche negli
                                Stati Uniti. Qualora si verifichi tale trasferimento, esso avverrà con garanzie adeguate, ad
                                esempio in base alle Clausole Contrattuali Standard adottate dalla Commissione Europea con la
                                Decisione di Esecuzione (UE) n. 2021/914. Per ulteriori informazioni sulle garanzie offerte da
                                Apple nel contesto dei trasferimenti di dati personali, si prega di visitare la sezione
                                dell'informativa sulla privacy di Apple dedicata ai trasferimenti, disponibile all'indirizzo{' '}
                                <a href="https://www.apple.com/it/legal/privacy/">https://www.apple.com/it/legal/privacy/</a>.
                            </p>
                        </div>
                        <div>
                            <h1>
                                <i>4.1.1.2. Google</i>
                            </h1>
                            <p>È inoltre possibile registrarsi e accedere all’App con il proprio account Google</p>
                            <p>
                                Se sceglie di avvalerti di questa funzionalità, Google Ireland Limited, con sede a Gordon House,
                                Barrow Street, Dublino 4, Irlanda o l'altra entità del Gruppo Google che fornisce il servizio (di
                                seguito, “<b>Google</b>”) ci fornirà alcune informazioni su di lei (ad esempio, nome, indirizzo
                                e-mail e immagine del profilo Google), necessarie per permetterle di accedere all’App.
                            </p>
                            <p>
                                La preghiamo di notare che, nel contesto del meccanismo di single sign-on, Google tratterà i suoi
                                dati personali in qualità di autonomo titolare del trattamento per le proprie finalità. Per
                                ottenere maggiori informazioni sul trattamento dei dati personali effettuato da Google attraverso
                                il meccanismo di single sign-on, si prega di consultare questa pagina{' '}
                                <a href="https://support.google.com/accounts/answer/12921417?sjid=6885607619420952891-EU&hl=it">
                                    https://support.google.com/accounts/answer/12921417?sjid=6885607619420952891-EU&hl=it
                                </a>
                                , nonché l'informativa sulla privacy di Google, disponibile all'indirizzo:{' '}
                                <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>.
                            </p>
                            <p>
                                La informiamo che Google potrebbe trasferire i suoi dati personali al di fuori del SEE, anche
                                negli Stati Uniti. Qualora si verifichi tale trasferimento, esso avverrà nel rispetto di garanzie
                                adeguate, quali il Data Privacy Framework EU-USA, al quale Google ha certificato la propria
                                partecipazione, o le Clausole contrattuali standard adottate dalla Commissione europea con la
                                Decisione di esecuzione (UE) n. 2021/914. Per ulteriori informazioni sulle garanzie implementate
                                da Google nel contesto dei trasferimenti di dati personali, si prega di visitare il sito{' '}
                                <a href="https://policies.google.com/privacy/frameworks?hl=it-US">
                                    https://policies.google.com/privacy/frameworks?hl=it-US
                                </a>
                                .
                            </p>
                        </div>
                        <div>
                            <h1 className={classes.underline}>4.1.2. Piattaforme di pagamento</h1>
                        </div>
                        <div>
                            <h1>
                                <i>4.1.2.1. Nexi</i>
                            </h1>
                            <p>
                                Per l'esecuzione dei pagamenti attraverso l’App, abbiamo individuato Nexi quale fornitore di
                                servizi di pagamento. In questo contesto, Nexi Payments S.p.A. avente sede in Milano, Corso
                                Sempione n. 55 che fornisce il servizio (di seguito “<b>Nexi</b>”) tratta i dati personali in
                                qualità di autonomo titolare del trattamento.
                            </p>
                            <p>
                                Per ottenere maggiori informazioni su tale trattamento di dati personali, la invitiamo a
                                consultare l'informativa privacy di Nexi, disponibile all'indirizzo{' '}
                                <a href="https://www.nexi.it/it/privacy/xpay">https://www.nexi.it/it/privacy/xpay</a>, nonché la
                                seguente pagina:{' '}
                                <a href="https://ecommerce.nexi.it/specifiche-tecniche/iframe.html#:~:text=Informativa%20privacy%3A%20occorre%20riportare%20l,il%20testo%20risulti%20sempre%20aggiornato">
                                    https://ecommerce.nexi.it/specifiche-tecniche/iframe.html#:~:text=Informativa%20privacy%3A%20occorre%20riportare%20l,il%20testo%20risulti%20sempre%20aggiornato
                                </a>
                                .
                            </p>
                            <p>
                                La informiamo inoltre che Nexi potrebbe trasferire i suoi dati personali al di fuori del SEE.
                                Qualora si verifichi tale trasferimento, esso avverrà nel rispetto della normativa applicabile in
                                materia di protezione dei dati personali.
                            </p>
                        </div>
                        <div>
                            <h1>5. I SUOI DIRITTI</h1>
                            <p>
                                La sua privacy è una nostra priorità e ci impegniamo quotidianamente a garantire la protezione dei
                                suoi dati personali. In ogni momento, nei limiti in cui ricorrano le condizioni previste per
                                legge, potrà esercitare i diritti a lei riconosciuti dalla normativa applicabile. In particolare,
                                ha il diritto di chiederci l’accesso ai suoi dati personali, la rettifica e la cancellazione degli
                                stessi, di opporsi al loro trattamento e, ove applicabile, di richiedere di non essere sottoposto
                                ad una decisione basata unicamente sul trattamento automatizzato, compresa la profilazione. La
                                legge le consente altresì di esercitare il diritto di richiedere la limitazione del trattamento
                                nei casi previsti dall’art. 18 del GDPR, nonché di ottenere i dati personali che la riguardano in
                                un formato strutturato, di uso comune e leggibile da dispositivo automatico, nei casi previsti
                                dall’art. 20 del GDPR. Le ricordiamo che ha sempre diritto di proporre reclamo al Garante per la
                                Protezione dei Dati Personali, ai sensi dell’art. 77 del GDPR, qualora lei ritenga che il
                                trattamento dei suoi dati personali sia contrario alla normativa in vigore.
                                <br />
                            </p>
                        </div>
                        <div>
                            <h1>5.1. Esercitare i diritti</h1>
                            <p>
                                In qualsiasi momento può esercitare, nella misura in cui ne ricorrano i presupposti di legge, i
                                diritti sopra richiamati. Fatto salve le modalità di esercizio dei diritti direttamente tramite
                                l’App secondo le modalità nel seguito descritte, può inviare una richiesta scritta mediante e-mail
                                all’indirizzo: <a href="mailto:privacy@sis.city">privacy@sis.city</a> inserendo nell’oggetto “
                                <span className={classes.underline}>Richiesta Privacy Muvin</span>”.
                            </p>
                        </div>
                        <div>
                            <h1>5.2. Verifica e gestione dei suoi dati</h1>
                            <p>
                                Per facilitare l’esercizio dei suoi diritti può accedere alla pagina personale del suo Profilo
                                Utente e modificare alcuni dati, inclusi quelli facoltativi da lei eventualmente conferiti. A tal
                                riguardo, le ricordiamo che al fine di poter consentire l’accesso ai servizi offerti tramite
                                l’App, abbiamo necessariamente bisogno di alcuni suoi dati personali, in assenza dei quali non
                                possiamo consentirle di mantenere attivo il suo Profilo Utente e di usufruire dei servizi offerti
                                tramite l’App da SIS.
                            </p>
                        </div>
                        <div>
                            <h1>5.3. Cancellazione del Profilo Utente</h1>
                            <p>Puoi cancellare il Profilo Utente:</p>
                            <ol type="a">
                                <li>
                                    <p>
                                        direttamente dall’App, tramite l’apposita sezione:{' '}
                                        <b>
                                            “Profilo” {'>'} “Account” {'>'} “Dati personali” {'>'} “Elimina account”
                                        </b>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        inviando un’e-mail all’indirizzo sisparcheggi@pec.it inserendo come oggetto “
                                        <span className={classes.underline}>Cancellazione Profilo Utente Muvin</span>”.
                                    </p>
                                </li>
                            </ol>
                            <p>
                                Una volta ricevuta la richiesta di cancellazione, provvederemo a disattivare immediatamente il suo
                                Profilo Utente, entro il termine di 30 giorni dal ricevimento, ad eliminare tutti i dati personali
                                presenti nei nostri archivi collegati al suo Profilo Utente, nonché ad inoltrare la relativa
                                richiesta ai soggetti terzi che trattano i suoi dati personali per conto nostro.
                                <br />
                                Conserveremo comunque i suoi dati personali per un periodo non superiore a 3 mesi per finalità
                                esclusivamente amministrative, riservandoci, in casi specifici, di estendere tale periodo di
                                conservazione al fine di poter tutelare i nostri legittimi interessi ovvero ove ciò sia necessario
                                in ottemperanza alla normativa applicabile. Da ultimo, la informiamo del fatto che alcuni dati
                                personali potrebbero essere anonimizzati e mantenuti per sole finalità statistiche. In tal caso, i
                                dati oggetto di anonimizzazione, comunque, non sarebbero più riconducibili a lei e, quindi, non
                                sarebbero più qualificabili come personali.
                            </p>
                            <p>
                                <span className={classes.underline}>
                                    A seguito del mancato accesso al suo Profilo Utente tramite l’App per un periodo superiore a
                                    24 mesi, provvederemo a cancellare il suo Profilo utente e tutti i suoi dati personali
                                </span>
                                , fatta salva l’eventuale ulteriore conservazione di tali dati ove necessaria al fine di adempiere
                                ad obblighi di legge e/o di tutelare i nostri legittimi interessi.{' '}
                                <span className={classes.underline}>
                                    Prima di procedere alla cancellazione del suo Profilo Utente, tuttavia, la contatteremo
                                    affinché lei ci possa comunicare se desidera mantenerlo attivo.
                                </span>{' '}
                                In caso di suo riscontro negativo o in assenza di riscontro, provvederemo a cancellare il Profilo
                                Utente, sicché non sarà più in grado di accedervi con le vecchie credenziali e, ove fosse
                                interessato a continuare ad usufruire dei servizi messi a disposizione da SIS tramite l’App, dovrà
                                crearne uno nuovo.
                            </p>
                        </div>
                        <div>
                            <h1>5.4. Gestione dei consensi</h1>
                            <p>
                                In ogni momento le garantiamo la possibilità di revocare e/o modificare molto facilmente il
                                consenso in precedenza reso finalità di marketing diretto, tramite l’apposita sezione:{' '}
                                <b>
                                    “Profilo” {'>'}
                                    “Informazioni legali”
                                </b>{' '}
                                e decidere di revocare il consenso precedentemente reso con un semplice “<i>tap</i>”. Le facciamo
                                presente che la revoca del consenso non pregiudica la liceità del trattamento basata sul consenso
                                prestato prima della revoca stessa e i trattamenti dei dati personali fondati su altre basi
                                giuridiche. Le ricordiamo che, sempre tramite la sopracitata sezione
                                <b> “Profilo” {'>'} “Informazioni legali”</b> potrà anche, in qualsiasi momento e in tutta
                                semplicità, limitare le attività di marketing alle sole notifiche <i>push</i>, oggetto di separato
                                consenso.
                            </p>
                        </div>
                        <div>
                            <h1>6. COME GARANTIAMO LA PROTEZIONE DEI SUOI DATI PERSONALI</h1>
                            <p>
                                Al fine di garantire la sicurezza dei suoi dati personali, tenendo conto dello stato dell’arte e
                                dei costi di attuazione, nonché della natura, dell’oggetto, del contesto e delle finalità del
                                trattamento, come anche del rischio di varia probabilità e gravità per i diritti e le libertà
                                delle persone fisiche, abbiamo adottato misure tecniche e organizzative adeguate per assicurare un
                                livello di sicurezza adeguato al rischio. In particolare, abbiamo adottato misure di sicurezza che
                                consentono:
                            </p>
                            <ul>
                                <li>
                                    <p>la pseudonimizzazione o la cifratura dei suoi dati; </p>
                                </li>
                                <li>
                                    <p>la riservatezza, l’integrità, e la disponibilità dei suoi dati;</p>
                                </li>
                                <li>
                                    <p>la resilienza dei sistemi e dei servizi che elaborano i dati;</p>
                                </li>
                                <li>
                                    <p>la capacità di ripristinare i dati in caso di data breach.</p>
                                </li>
                            </ul>
                            <p>
                                Inoltre, ad eccezione della registrazione all’App tramite il meccanismo di Single Sign-On, al fine
                                di verificare l’autenticità della richiesta di registrazione e di completare la creazione del suo
                                Profilo Utente, abbiamo implementato un sistema di attivazione di quest’ultimo. Difatti, una volta
                                completata la registrazione, invieremo al numero di telefono indicato nel form di registrazione
                                una c.d. <i>One Time Password</i> (nel seguito, “<b>OTP</b>”) per l’autenticazione all’App e la
                                verifica dei contatti indicati in sede di registrazione. Una volta confermata la sua identità come
                                sopra indicato, SIS le invierà una seconda comunicazione in cui saranno contenuti i riferimenti
                                alla presente Privacy Policy e alle Condizioni Generali dell’App. Le ricordiamo che sarà sua cura
                                provvedere alla conservazione di questa comunicazione. <br />
                                Una volta attivato il proprio Profilo Utente, per autenticarsi in occasione dei successivi accessi
                                all’App, l’Utente avrà la possibilità, alternativamente, di creare una password tramite
                                un’apposita sezione dell’App, ovvero di continuare ad autenticarsi con codici OTP come avvenuto al
                                momento della creazione del Profilo Utente, fatto salvo il caso in cui l’Utente utilizzi il
                                meccanismo di Single Sign-On, nel qual caso dovrà sempre inserire la password del proprio account
                                Apple o Google. <br />
                                Con riferimento alla gestione delle credenziali per accedere al proprio Profilo Utente, abbiamo
                                previsto, sin dalla fase di progettazione, una logica di autenticazione che impone agli utenti di
                                utilizzare delle password con alti livelli di robustezza. A tal riguardo, ricordiamo che, per una
                                sua maggiore sicurezza, l’utente è tenuto, in ogni caso, a conservare con cura le proprie
                                credenziali e a non concedere a soggetti terzi l’accesso al proprio profilo Utente.
                            </p>
                        </div>
                        <div>
                            <h1>7. AGGIORNAMENTO DELLA PRESENTE PRIVACY POLICY</h1>
                            <p>
                                La presente Privacy Policy è stata pubblicata il 13/06/2025 e potrà subire modifiche nel tempo,
                                anche connesse all'eventuale entrata in vigore di nuove normative di settore, all'aggiornamento o
                                erogazione di nuovi servizi ovvero ad intervenute innovazioni tecnologiche. La informeremo di tali
                                variazioni non appena verranno introdotte ed esse saranno vincolanti non appena pubblicate. La
                                invitiamo, quindi, a visitare con regolarità l’apposita sezione{' '}
                                <b>“Profilo” {'>'} “Informazioni legali”</b> dell’App per prendere cognizione della più recente ed
                                aggiornata versione della Privacy Policy sul trattamento dei dati personali in modo da essere
                                sempre aggiornato sui dati raccolti e sull’uso che ne facciamo.
                            </p>
                        </div>
                    </div>
                    <section id="delete" className={classes.delete}>
                        <h1>Come posso cancellare il mio account?</h1>
                        <p>Per eliminare il tuo account segui i seguenti step:</p>
                        <ol type="1">
                            <li>
                                <p>
                                    Apri l'App <b>Muvin</b>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Effettua il <b>login</b> (se non sei gia' loggato)
                                </p>
                                <img src="/assets/images/screen_login.png" alt="Login Screen" />
                            </li>
                            <li>
                                <p>
                                    Apri la sezione <b>Profilo</b>
                                </p>
                                <img src="/assets/images/screen_profile.png" alt="Profile Screen" />
                            </li>
                            <li>
                                <p>
                                    Vai su <b>Account</b>
                                </p>
                                <img src="/assets/images/screen_account.png" alt="Account Screen" />
                            </li>
                            <li>
                                <p>
                                    <b>Dati personali</b>
                                </p>
                                <img src="/assets/images/screen_personal.png" alt="Personal data Screen" />
                            </li>
                            <li>
                                <p>
                                    Clicca su <b>Elimina account</b>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Infine clicca su <b>Elimina</b>
                                </p>
                                <img src="/assets/images/screen_delete.png" alt="Delete Screen" />
                            </li>
                        </ol>
                        <p>
                            Questa azione sarà irreversibile e provvederemo immediatamente a cancellare i dati relativi al tuo
                            account in maniera permanente senza possibilità di recupero.
                        </p>
                    </section>
                </div>
                <footer className={classes.footer}>
                    <img src="/assets/images/logo_muvin_color.png" alt="logo muvin" className={classes.logo} />
                    muvin
                    <img src="/assets/svg/logo_sis.svg" alt="logo muvin" className={classes.logo} />
                </footer>
            </main>
        </div>
    );
};

export default PrivacyPolicy;

